<template>
  <z-paging
    :refresher-enabled="refresherEnabled"
    :fixed="fixed"
    ref="zPagingRef"
    v-model="currentArr"
    @query="queryList"
    @scroll="scroll"
    :inside-more="insideMore"
    class="common-scroll"
    lower-threshold="100rpx"
    :loading-more-no-more-text="loadingMoreNoMoreText"
    :refresher-default-text="refresherDefaultText"
    :refresher-pulling-text="refresherPullingText"
    :show-loading-more-no-more-line="showLoadingMoreNoMoreLine"
    :show-refresher-when-reload="showRefresherWhenReload"
    :hide-empty-view="hideEmptyView"
    :auto-scroll-to-top-when-reload="autoScrollToTopWhenReload"
    :auto-clean-list-when-reload="autoCleanListWhenReload"
    :show-loading-more-when-reload="showLoadingMoreWhenReload"
    :scroll-with-animation="scrollWithAnimation"
    :back-to-top-with-animate="true"
    @listChange="listChange"
  >
    <!-- z-paging是否使用fixed布局，若使用fixed布局，则z-paging的父view无需固定高度，z-paging高度默认铺满屏幕，页面中的view请放在z-paging标签内，需要固定在顶部的view使用slot="top"包住，需要固定在底部的view使用slot="bottom"包住。 -->
    <slot name="top"></slot>
    <slot name="content" :currentArr="currentArr"> </slot>
    <slot v-if="currentArr.length <= 0 && showEmpty" name="empty"> </slot>
    <slot name="bottom"></slot>
  </z-paging>
</template>
<script setup lang="ts">
import { nextTick, ref } from 'vue'
const emit = defineEmits<{
  (e: 'scroll', event: any): void
  (e: 'query', pageNo: number, pageSize: number): void
  (e: 'listChange', data: any): void
}>()
const zPagingRef = ref<any>(null)
const props = defineProps({
  // 是否绝对定位
  fixed: {
    type: Boolean,
    default: false
  },
  // 底部加载完毕没有数据的文案
  loadingMoreNoMoreText: {
    type: String,
    default: '我也是有底线的！'
  },
  // 下拉文案
  refresherDefaultText: {
    type: String,
    default: '下拉可刷新'
  },
  // 释放前文案
  refresherPullingText: {
    type: String,
    default: '释放立即刷新'
  },
  // 底部加载完的文案两边是否加线
  showLoadingMoreNoMoreLine: {
    type: Boolean,
    default: false
  },
  // reload是展示加载中
  showRefresherWhenReload: {
    type: Boolean,
    default: true
  },
  //  加载不满一屏幕是否继续加载
  insideMore: {
    type: Boolean,
    default: true
  },
  // 是否开启下拉刷新
  refresherEnabled: {
    type: Boolean,
    default: true
  },
  // 是否强制隐藏空数据图
  hideEmptyView: {
    type: Boolean,
    default: true
  },
  // reload时自动滚动到顶部
  autoScrollToTopWhenReload: {
    type: Boolean,
    default: true
  },
  //reload时立即自动清空原list，若立即自动清空，则在reload之后、请求回调之前页面是空白的
  autoCleanListWhenReload: {
    type: Boolean,
    default: true
  },
  //  列表刷新时自动显示加载更多view，且为加载中状态
  // (仅初始设置有效，不可动态修改)
  showLoadingMoreWhenReload: {
    type: Boolean,
    default: false
  },
  // 在设置滚动条位置时使用动画过渡
  scrollWithAnimation: {
    type: Boolean,
    default: true
  }
})
let showEmpty = ref(false)
let currentArr = ref<any>([])
const scroll = (event) => {
  emit('scroll', event)
}
const queryList = (pageNo, pageSize) => {
  emit('query', pageNo, pageSize)
}
const reload = () => {
  showEmpty.value = false
  zPagingRef.value.reload()
}
const complete = (arg) => {
  zPagingRef.value.complete(arg)
  setTimeout(() => {
    if (!showEmpty.value) {
      showEmpty.value = true
    }
  }, 500)
}
const scrollToTop = () => {
  zPagingRef.value.scrollToTop()
}
// 分页渲染的数组改变时触发/最终的分页数据数组
const listChange = (list) => {
  emit('listChange', list)
}

const timeFinish = (item) => {
  const cloneData = JSON.parse(JSON.stringify(currentArr.value))
  currentArr.value = cloneData.map((e) => {
    if (e.id === item.id) {
      if (item.progress_status === 2) {
        // 未开始
        e.progress_status = 1
      }
      if (item.progress_status === 1) {
        // 进行中
        if (item.complete_num === item.goal_num) {
          // 进度完成
          e.progress_status = 3
        } else {
          e.progress_status = 4
        }
      }
    }
    return e
  })
}

defineExpose({
  reload,
  complete,
  scrollToTop,
  timeFinish
})
</script>
<style lang="scss" scoped>
.common-scroll {
  top: 0;
  left: 0;
}
:deep(.zp-l-container) {
  height: 100rpx;
  .zp-l-text {
    font-size: 20rpx !important;
    color: #5c5f7a !important;
  }
}
</style>
